import React, { useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { useColorTheme } from "./contexts/ThemeContext";
import { createBiosTheme } from "./theme";

/**
 * Subscribes MUI ThemeProvider to the same light/dark mode as Tailwind (`html.dark`).
 */
export default function MuiThemeBridge({ children }) {
  const { theme: siteMode } = useColorTheme();
  const muiTheme = useMemo(() => createBiosTheme(siteMode), [siteMode]);
  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
}
